<template>
  <div id="app" class="app">
    <transition name="page" appear>
        <Navbar/>
    </transition>
    <transition name="page" mode="out-in">
        <router-view/>
    </transition>
    <Foot/>
  </div>
</template>
<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import Foot from '@/components/Foot.vue'
import { mapActions, mapGetters } from 'vuex'

import { db } from '@/firebase'

var generalRef = db.ref('/flamelink/environments/production/content/general/en-US')
var workRef = db.ref('/flamelink/environments/production/content/home/en-US')
var informationRef = db.ref('/flamelink/environments/production/content/information/en-US')
var projectRef = db.ref('/flamelink/environments/production/content/project/en-US/')
var privateProjectRef = db.ref('/flamelink/environments/production/content/privateProject/en-US/')

export default {
  name: 'app',
  components: {
    Navbar,
    Foot
  },
  methods: {
    ...mapActions([
      'setGeneralRef',
      'setWorkRef',
      'setInformationRef',
      'setProjectRef',
      'setPrivateProjectRef'
    ])
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'getRole',
      'getEmail'
    ])
  },
  created () {
    this.setGeneralRef(generalRef)
    this.setWorkRef(workRef)
    this.setInformationRef(informationRef)
    this.setProjectRef(projectRef)
    this.setPrivateProjectRef(privateProjectRef)
  }
}
</script>
<style lang="scss">
  @import "./scss/fonts";
  @import "./scss/vars";

html {
    scroll-behavior: smooth;
}

  body {
    color: $font-color__main;
    -webkit-transition: background-color 1000ms ease;
    -ms-transition: background-color 1000ms ease;
    transition: background-color 1000ms ease;
  }
 
.fade-in-enter {
    opacity: 0;
}

.fade-in-enter-active {
    animation: 1s ease 2s 1 slideInFromTop;
    opacity: 0;
}

.fade-in-leave {
    opacity: 1;
}

.fade-in-leave-active {
    animation: 0.5s ease 0s 1 slideInFromTop reverse;
}

@keyframes slideInFromTop {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
    
.page-enter {
    opacity: 0;
}

.page-enter-active {
    animation: 0.8s ease 0s 1 pageAnim;
    opacity: 0;
}

.page-leave {
    opacity: 1;
}

.page-leave-active {
    animation: 0.5s ease 0s 1 pageAnim reverse;
}

@keyframes pageAnim {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>
